import axios_crm from "../../../store/axios/axios-crm";
import { getContactAddress } from "../../../shared/utility";

export const fetchPropertyOwners = async (propertyId) => {
    if (!propertyId) return [];
    try {
        const response = await axios_crm.get('/property_owners_contacts?id=' + propertyId);
        return Array.isArray(response.data) ? response.data : [];
    } catch (e) {
        console.log('fetchPropertyOwners error', e);
        return [];
    }
};

export const buildLessorFromContact = (c) => {
    const a = getContactAddress(c) || {};
    return {
        name: c.first_name || '',
        last_name: c.last_name || '',
        contact_id: c.id,
        address1: a.street1 || '',
        address2: a.street2 || '',
        city: a.city || '',
        state: a.state || '',
        zip: a.zip || '',
        main_phone: c.main_phone || '',
        mobile_phone: c.mobile_phone || '',
        work_phone: c.work_phone || '',
        phone_type: 'Main',
        fax: c.fax || '',
        email: c.email || ''
    };
};
